import React, {useState} from "react";
import {IPeriod} from "../interfaces/IPeriod";
import {IYear} from "../interfaces/IYear";
import {IInvoice} from "../interfaces/IInvoice";
import {IMonthlyInvoice} from "../interfaces/MonthlyInvoice/IMonthlyInvoice";


type AccountingContextType = {
    selectedYear: IYear | undefined,
    selectYear: (year: IYear | undefined) => void,

    selectedPeriod: IPeriod | undefined,
    selectPeriod: (period: IPeriod | undefined) => void,

    selectedInvoice: IInvoice | undefined,
    selectInvoice: (invoice: IInvoice | undefined) => void,

    selectedMonthlyInvoice: IMonthlyInvoice | undefined,
    selectMonthlyInvoice: (invoice: IMonthlyInvoice | undefined) => void,

    isMonthlyInvoiceOverlayOpen: boolean,
    selectIsMonthlyInvoiceOverlayOpen: (isMonthlyInvoiceOverlayOpen: boolean) => void;

    isMonthlyInvoiceFormOpen: boolean,
    selectIsMonthlyInvoiceFormOpen: (isMonthlyInvoiceFormOpen: boolean) => void;
}

const AccountingContext = React.createContext<AccountingContextType | undefined>(undefined);

function useAccountingContextValue() {
    const [selectedYear, setSelectedYear] = useState<IYear | undefined>();
    const [selectedPeriod, setSelectedPeriod] = useState<IPeriod | undefined>();
    const [selectedInvoice, setSelectedInvoice] = useState<IInvoice | undefined>();
    const [selectedMonthlyInvoice, setSelectedMontlyInvoice] = useState<IMonthlyInvoice | undefined>();
    const [isMonthlyInvoiceOverlayOpen, setIsMonthlyInvoiceOverlayOpen] = useState<boolean>(false);
    const [isMonthlyInvoiceFormOpen, setIsMonthlyInvoiceFormOpen] = useState<boolean>(false);

    const selectYear = (year: IYear | undefined) => {
        setSelectedYear(year);
    }

    const selectPeriod = (period: IPeriod | undefined) => {
        setSelectedPeriod(period);
    }

    const selectInvoice = (invoice: IInvoice | undefined) => {
        setSelectedInvoice(invoice);
    }
    const selectMonthlyInvoice = (invoice: IMonthlyInvoice | undefined) => {
        setSelectedMontlyInvoice(invoice);
    }

    const selectIsMonthlyInvoiceOverlayOpen = () => {
        setIsMonthlyInvoiceOverlayOpen(!isMonthlyInvoiceOverlayOpen);
    }

    const selectIsMonthlyInvoiceFormOpen = () => {
        setIsMonthlyInvoiceFormOpen(!isMonthlyInvoiceFormOpen);
    }


    return {
        selectedYear, selectYear,
        selectedPeriod, selectPeriod,
        selectedInvoice, selectInvoice,
        selectedMonthlyInvoice, selectMonthlyInvoice,
        isMonthlyInvoiceOverlayOpen, selectIsMonthlyInvoiceOverlayOpen,
        isMonthlyInvoiceFormOpen, selectIsMonthlyInvoiceFormOpen,
    }
}

function AccountingProvider({children}: { children: React.ReactNode }) {
    const value = useAccountingContextValue();
    return <AccountingContext.Provider value={value}>{children}</AccountingContext.Provider>
}

function useAccounting() {
    const context = React.useContext(AccountingContext);
    if (!context) {
        throw new Error('useAccounting must be used within a AccountingProvider');
    }
    return context;
}

export {
    AccountingProvider,
    useAccounting,
}